import { TFunction } from 'react-i18next';
import {
  OrderDetailsFormFieldsNames,
  UpdateOrderDeliveryFormFieldsNames,
  UpdateOrderClientFormFieldsNames,
} from './types';
import {
  useGetEmailRule,
  useGetFullNameRule,
  useGetPhoneRule,
  useGetRequiredRule,
  useLengthValidationRule,
} from '@/hooks';

export const useUpdateOrderDeliveryFormRules = (t: TFunction) => {
  const requiredRule = useGetRequiredRule({ t });
  const nameFieldLength = useLengthValidationRule({ t, max: 200 });

  return {
    [UpdateOrderDeliveryFormFieldsNames.DELIVERY_TYPE]: [requiredRule],
    [UpdateOrderDeliveryFormFieldsNames.SETTLEMENT]: [requiredRule],
    [UpdateOrderDeliveryFormFieldsNames.ADDRESS]: [requiredRule],
    [UpdateOrderDeliveryFormFieldsNames.BUILDING_TYPE]: [requiredRule],
    [UpdateOrderDeliveryFormFieldsNames.DELIVERY_WAREHOUSE]: [requiredRule],
    [UpdateOrderDeliveryFormFieldsNames.DELIVERY_DEPARTMENT]: [requiredRule],
    [UpdateOrderDeliveryFormFieldsNames.COMMENT]: [nameFieldLength],
    [UpdateOrderDeliveryFormFieldsNames.FLOOR]: [requiredRule],
    [UpdateOrderDeliveryFormFieldsNames.FLAT_NUMBER]: [requiredRule],
    [UpdateOrderDeliveryFormFieldsNames.ELEVATOR]: [requiredRule],
  };
};

export const useUpdateProductsAndCommentsFormRules = (t: TFunction) => {
  const requiredRule = useGetRequiredRule({ t });

  const orderCommentLengthRule = {
    max: 1000,
    message: t('order_comment_length_validation'),
  };

  return {
    [OrderDetailsFormFieldsNames.PRODUCTS]: {
      default: [requiredRule],
    },
    [OrderDetailsFormFieldsNames.COMMENTS]: {
      default: [orderCommentLengthRule],
    },
  };
};

export const useUpdateOrderClientFormRules = (t: TFunction) => {
  const requiredRule = useGetRequiredRule({ t });
  const nameFieldLength = useLengthValidationRule({ t, max: 200 });
  const phoneRule = useGetPhoneRule({ t });
  const nameRule = useGetFullNameRule({ t });
  const email = useGetEmailRule({ t });

  return {
    [UpdateOrderClientFormFieldsNames.NAME]: [requiredRule, nameRule],
    [UpdateOrderClientFormFieldsNames.PHONE]: [requiredRule, phoneRule],
    [UpdateOrderClientFormFieldsNames.EMAIL]: [requiredRule, email],
    [UpdateOrderClientFormFieldsNames.DESCRIPTION]: [nameFieldLength],
  };
};
